class SearchDiscovery extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    let requestResponse;

    const body = document.body;
    const searchInput = document.querySelector('.js-search-input-main');
    const searchSuggestionsSection = this.querySelector('.js-search-discovery-suggestions');
    const placeholderHTML = searchSuggestionsSection.querySelector('#shopify-section-search-discovery-suggestions').innerHTML;

    if (!searchInput) return;

    const classes = {
      active: 'search-discovery-active',
      suggestionsLoading: 'search-discovery-suggestions-loading'
    };

    const showPlaceholder = () => {
      searchSuggestionsSection.innerHTML = placeholderHTML;
      body.classList.remove(classes.suggestionsLoading);
      document.dispatchEvent(new Event('asyncSlider:ready'));
    };

    const openSearch = () => {
      body.classList.add(classes.active);
    };

    const closeSearch = () => {
      searchInput.blur();
      body.classList.remove(classes.active);
    };

    this.addEventListener('transitionend', () => {
      if (body.classList.contains(classes.active) && searchInput.value == '') {
        searchInput.focus();
      }
    });

    this.addEventListener('focusin', () => {
      openSearch();
    });

    this.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement) && document.activeElement !== searchInput) {
          closeSearch();
        }
      }, 0);
    });

    searchInput.addEventListener('focus', () => {
      openSearch();
    });

    searchInput.addEventListener('input', debounce((e) => {
      if (!e.target.value) {
        showPlaceholder();
        return;
      };

      if (body.classList.contains(classes.suggestionsLoading)) return;

      body.classList.add(classes.active, classes.suggestionsLoading);

      fetch(`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(e.target.value)}&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title&resources[limit_scope]=each&section_id=search-discovery-suggestions`)
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          showPlaceholder();
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        const results = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-discovery-suggestions').innerHTML;

        searchSuggestionsSection.innerHTML = results;
        body.classList.remove(classes.suggestionsLoading);
        document.dispatchEvent(new Event('asyncSlider:ready'));
      })
      .catch((error) => {
        showPlaceholder();
        console.error(error);
      });
    }, 500));

    document.addEventListener('searchDiscovery:close', () => {
      closeSearch();
    });

    body.addEventListener('click', (e) => {
      const clickInside = this.contains(e.target) || e.target === searchInput;

      if (!clickInside) {
        closeSearch();
      }
    });
  }
}

customElements.define('search-discovery', SearchDiscovery);
